<template>
  <div class="position-relative mt-3" id="SchemaDefinitionTable">

    <div class="actions text-right" id="SchemaDefinitionTable-showAddEditDialog">
      <button class="btn btn-primary icon-button" @click="showAddEditDialog = true" id="SchemaDefinitionTable-add-Button">
        <span class="btn-icon" id="SchemaDefinitionTable-addButton-span"><i class="fa fa-plus" aria-hidden="true" id="SchemaDefinitionTable-addButton-data"></i></span>
        {{ 'ADD' | translate }}
      </button>
    </div>

    <vodal :show="showAddEditDialog" :width="400" :closeOnEsc="true" :closeOnClickMask="false"
      :customStyles="{ 'top': '80px', 'bottom': 'auto', 'height': 'auto' }" animation="rotate" @hide="closeDialog"
      id="SchemaDefinitionTableAddEditDialog-modal">
      <schema-definition-add-edit-dialog :loaded="loaded" :edited="editedRow" :errorMessage="errorMessage" @save="onSaveNew"
        @update="onUpdate" @close="closeDialog" @clearErrorMessage="clearErrorMessage"
        id="SchemaDefinitionTableAddEditDialog-schemaDefinitionDialog"></schema-definition-add-edit-dialog>
    </vodal>
    <table class="table table-striped table-hover" id="SchemaDefinitionTable-tableData">
      <caption></caption>
      <tr>
        <th>File Name</th>
        <th>Scheme Definition</th>
        <th></th>
      </tr>
      <template v-for="row in rows">
        <tr>
          <td>{{ row.fileName }}</td>
          <td id="SchemaDefinitionTable-textArea">
            <textarea class="textarea" readonly disabled>{{ row.xsdFileData }}</textarea>
          </td>
          <td id="SchemaDefinitionTable-tableButtons">
            <button class="btn btn-success icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('EDIT')" @click="onEdit(row)" :id="'SchemaDefinitionTable-tableEditButton-'+row.fileName">
              <span class="btn-icon" :id="'SchemaDefinitionTable-tableEditSpan-'+row.fileName"><i class="fa fa-pencil" aria-hidden="true" :id="'SchemaDefinitionTable-tableEditData-'+row.fileName"></i></span>
            </button>
            <button class="btn btn-danger icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('DELETE')" @click="confirmDelete(row)" :id="'SchemaDefinitionTable-tableDeleteButton-'+row.fileName">
              <span class="btn-icon" :id="'SchemaDefinitionTable-tableDeleteSpan-'+row.fileName"><i class="fa fa-trash-o" aria-hidden="true" :id="'SchemaDefinitionTable-tableDeleteData-'+row.fileName"></i></span>
            </button>
          </td>
        </tr>
      </template>
    </table>
    <confirm-dialog :show="showDeleteConfirmDialog" :textLabel="'Are you sure you want to delete this?'"
              @hide-dialog="showDeleteConfirmDialog = false" @confirm="onRemove(selectedRow.id)">
            </confirm-dialog>
  </div>
</template>

<script>
import RestService from '../../../service/RestService.js';
import Datepicker from 'vuejs-datepicker';
import Vodal from 'vodal';
import SchemaDefinitionAddEditDialog from './SchemaDefinitionAddEditDialog.vue';
import ConfirmDialog from '../../dialog/ConfirmDialog.vue';

export default {
  components: { SchemaDefinitionAddEditDialog, Datepicker, Vodal, ConfirmDialog },
  data() {
    return {
      rest: this.initRestService(),
      filter: '',
      rows: [],
      newRows: [],
      editedRow: null,
      showAddEditDialog: false,
      errorMessage: '',
      loaded: false,
      showDeleteConfirmDialog: false,
      selectedRow: null
    }
  },
  beforeMount() {
    this.loadRows();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async loadRows() {
      const mappingResponse = await this.rest.getAllSchemaDefinitions();
      this.rows = mappingResponse.data;
    },
    onEdit(row) {
      this.editedRow = row;
      this.showAddEditDialog = true;
    },
    async onSaveNew(formData) {
      const vm = this;
      this.loaded = true;
      this.rest.postToServer('/schemaDefination', formData)
        .then((response) => {
          this.closeDialog();
          this.loadRows();
          this.loaded = false;
          this.$notify({
            type: 'alert-success',
            text: this.$options.filters.translate('msg.DROOLS_RESET_CREATED')
          });
        }).catch((err) => {
          if (typeof err.response !== 'undefined') {
            this.$log.error(err.response.data);
          } else {
            this.$log.error(err);
          }
          this.loaded = false;
          vm.submitting = false;
          vm.setErrorMessage(this.$options.filters.translate('CANT_UPLOAD_FILE', 'msg') + '\n' +
            this.$options.filters.translateApiMessage(err.response.data));
        });
    },
    async onUpdate(formData) {
      const vm = this;
      this.loaded = true;
      this.rest.postToServer('/schemaDefination', formData)
        .then((response) => {
          this.closeDialog();
          this.loadRows();
          this.loaded = false;
          this.$notify({
            type: 'alert-success',
            text: this.$options.filters.translate('msg.DROOLS_RESET_CREATED')
          });
        }).catch((err) => {
          if (typeof err.response !== 'undefined') {
            this.$log.error(err.response.data);
          } else {
            this.$log.error(err);
          }
          this.loaded = false;
          vm.submitting = false;
          vm.setErrorMessage(this.$options.filters.translate('CANT_UPLOAD_FILE', 'msg') + '\n' +
            this.$options.filters.translateApiMessage(err.response.data));
        });
    },
    onRemove(rowId) {
      this.rows = this.rows.filter(row => row.id !== rowId);
      this.rest.deleteSchemaDefinition(rowId);
      this.showDeleteConfirmDialog = false;
    },
    closeDialog() {
      this.showAddEditDialog = false;
      this.editedRow = false;
    },
    setErrorMessage: function (message) {
      this.errorMessage = message;
    },
    clearErrorMessage() {
      const vm = this;
      vm.setErrorMessage();
    },
    confirmDelete(row) {
      this.selectedRow = row;
      this.showDeleteConfirmDialog = true;
    }
  }

}
</script>

<style lang="scss" scoped>
.actions {
  position: absolute;
  z-index: 1;
  top: 10px;
  right: 0;

  .icon-button {
    padding-right: 15px;
    padding-left: 50px;
  }
}

.textarea {
  font-size: 16px;
  height: 200px;
  width: 800px;
}</style>



// WEBPACK FOOTER //
// src/components/admin/schema-definition/SchemaDefinitionTable.vue